import { defineStore } from 'pinia';

export const useErrorDialogStore = defineStore({
  id: 'error-dialog',
  state: () => ({
    isOpen: false,
  }),
  actions: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
});
